<app-page-header subtitle="Inventarisatie overzicht"></app-page-header>

<div class="container">
    <table class="table table-hover">
        <thead>
            <tr>
                <th>AFAS Project ID</th>
                <th>Opdrachtgever</th>
                <th>Locatie</th>
                <th>Datum</th>
                <th>Inventarisatiebehoefte</th>
                <th>Opmerking</th>
            </tr>
        </thead>
        <tbody>
            @for (planning of plannings; track planning.id) {
                <tr class="curpoint" (click)="openPlanning(planning)">
                    <td>{{ planning.afas_project_id }}</td>
                    <td>{{ planning.contractor }}</td>
                    <td>{{ planning.location | locationFormat }}</td>
                    <td>{{ planning.mainPlanning.begindate | date: 'dd-MM-yyyy' }}</td>
                    <td>{{ planning.data?.behoefteInventarisatie || 0 }} dagen</td>
                    <td>{{ planning.comment }}</td>
                </tr>
            }
        </tbody>
    </table>
</div>
